import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const UpdateProfilePhoto = gql`
  mutation UpdateProfilePhoto($input: UpdateProfilePhotoInput!) {
    updateProfilePhoto(input: $input) {
      __typename
      ... on UpdateProfilePhotoSuccess {
        customerInfo {
          profilePhotoDocumentId
          profilePhoto {
            url
            hash
          }
          name {
            first
            last
          }
        }
      }
      ... on UpdateProfilePhotoError {
        ...error
      }
      ... on Error {
        ...error
      }
    }
  }
  ${error}
`;

export default UpdateProfilePhoto;
